<template>
  <div>
    <product-menu></product-menu>
    <router-view></router-view>
    <product-footer></product-footer>
  </div>
</template>

<script>
    import ProductFooter from "./components/ProductFooter";
    import ProductMenu from "./components/ProductMenu";


    export default {
        name: 'App',
        components: { ProductFooter, ProductMenu },
        created() {
            this.$store.dispatch("getProductsAction");
            this.$store.dispatch("getCategoriesAction");
            this.$store.dispatch("getParametersAction");
        }
    }
</script>
